import { Calendar as CalendarComponent } from '@nextui-org/react';
import { I18nProvider } from "@react-aria/i18n";
import { parseDate } from "@internationalized/date";


const Calendar = ({ value, onChange, minValue, maxValue, ...props }) => {
  const parsedValue = value ? parseDate(value) : undefined;
  const parsedMinValue = minValue ? parseDate(minValue) : undefined;
  const parsedMaxValue = maxValue ? parseDate(maxValue) : undefined;

  const handleChange = (date) => {
    if (onChange) {
      onChange(date.toString());
    }
  };

  const isDateUnavailable = (date) => {
    const dayOfWeek = date.toDate().getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
  };

  return (
    <I18nProvider locale="es-VE">
      <CalendarComponent
        {...props}
        value={parsedValue}
        onChange={handleChange}
        minValue={parsedMinValue}
        maxValue={parsedMaxValue}
        isDateUnavailable={isDateUnavailable}
        errorMessage="Seleccione una fecha válida"
      />
    </I18nProvider>
  );
};

export default Calendar;